// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';
import { template } from 'lodash/fp';

export default {
  get CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('CATEGORY_REQUIRED_NAME')
      }
    };
  },

  get CATEGORY_TREE() {
    return {
      CONSTRAINTS: {
        CATEGORY_NAME: {
          presence: {
            presence: true,
            message: localizer.getText('CATEGORY_REQUIRED_NAME')
          }
        },
        SUB_CATEGORY_NAME: {
          presence: {
            presence: true,
            message: localizer.getText('CATEGORY_REQUIRED_SUBCATEGORY')
          }
        }
      },
      MESSAGES: {
        M03: localizer.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_CATEGORY'),
        M04: localizer.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_SUBCATEGORY')
      }
    };
  },

  get ERROR_MESSAGE_TEMPLATE() {
    return template(localizer.getText('CATEGORY_ERROR_MESSAGE_TEMPLATE'));
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.CategoryConstants.js